module.exports = __webpack_public_path__ + "nicon_upload_snapshot.svg";